import { useEffect, useState, useCallback }     from 'react';
import { Dialog, DialogBackdrop, DialogPanel }  from '@headlessui/react';
import { useFarol }                             from '../../contexts/FarolPageContext';
import api                                      from '../../services/api'
import "../../styles/FarolTextModal.css";

function FarolTextModal() {
    
    const { handleFarolTextModalClose, isFarolTextModalOpen, selectedPublicationId } = useFarol();
   
    const [ _publicationText, _setPublicationText ] = useState('');

    const _fetchPublicationlText = useCallback(async () => {

        // Limpa o texto anterior para não mostrar o de outra publicação se a busca falhar.
        _setPublicationText('');

        if (!selectedPublicationId) {
            _setPublicationText('Selecione uma publicação para gerar o texto.');
            return;
        }

        try {

            const response = await api.get(`/farolTerminalsText/${selectedPublicationId}`);

            const { textPublication } = response.data
            _setPublicationText(textPublication);

        } catch (error) {
            console.log(error);
            _setPublicationText(`Não foi possível gerar o texto: ${error.response?.data?.error || error.message}`);
        }

    },[ selectedPublicationId ])

    const copyToClipboard = () => {

        // navigator.clipboard só existe em HTTPS/localhost; fora disso copia pelo textarea.
        if (!navigator.clipboard) {
            const textArea = document.getElementById('text-area-FarolModalText');
            textArea.select();
            document.execCommand('copy');
            return;
        }

        navigator.clipboard.writeText(_publicationText).then(() => {
            console.log("Texto copiado para a área de transferência!");
        }).catch(err => {
            console.log("Falha ao copiar: ", err);
        });
    }

    useEffect(() => {

        if (!isFarolTextModalOpen) return;
        _fetchPublicationlText();

    }, [ isFarolTextModalOpen, _fetchPublicationlText ]);

    return (

        <Dialog open={isFarolTextModalOpen} onClose={handleFarolTextModalClose}  className="relative z-[100]">

        <DialogBackdrop onClick={handleFarolTextModalClose} transition className="fixed inset-0 bg-bg-backdrop transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"/>
        
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                
                <DialogPanel transition className="max-h-[70%] w-[808px] relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8  data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95">   
                    
                    <div className="app-container">
                        
                        <header className="bg-azul-profundo-m flex justify-between items-center pl-4 pr-1 py-3">
                            
                            <h2     className="text-white text-[1rem] leading-7 font-semibold">Lista de Faróis em texto</h2>
                            <button className="text-[1.2rem] text-white hover:text-gray-200 pr-2" onClick={handleFarolTextModalClose}  >×</button>
                            
                        </header>

                        <section className="py-3 px-4 ">
                            <pre className="bg-[#ececec] rounded-[5px] font-['Saira'] text-cinza-escuro overflow-auto overflow-hidden"> 
                                
                                <textarea 
                                    id='text-area-FarolModalText' 
                                    className='text-area-FarolModalText'
                                    value={_publicationText}
                                    onChange={(e) => _setPublicationText(e.target.value)}
                                ></textarea>
                            </pre>
                        </section>

                        <footer className="w-full bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                
                                <button 
                                    type="submit" 
                                    onClick={copyToClipboard} 
                                    className="btn btn-azul-prof w-[100%] text-[1.125rem]"
                                >
                                    Copiar Tudo
                                </button>

                        </footer>
                                
                    </div>

                </DialogPanel>
            
            </div>
        </div>
        </Dialog>
    );
}


export default FarolTextModal;




